export const dadosFilter = [
  { cod: 1, nome: 'IMPLEMENTAÇÃO', color: '#DEECFE', textColor: '#165DFF' },
  { cod: 2, nome: 'CORREÇÃO', color: '#FFF2CC', textColor: '#F2994A' },
  { cod: 4, nome: 'VISUAL', color: '#FADFEE', textColor: '#B04DF6' },
  { cod: 5, nome: 'REFATORAÇÃO', color: '#FFECCC', textColor: '#F2994A' },
]

export const cores = {
  1: { bg: '#E6F4EA', text: '#1E8E3E', border: '#CEEAD6', circle: '#1E8E3E' }, // Implementação: verde
  2: { bg: '#FCE8E6', text: '#D93025', border: '#FAD2CF', circle: '#D93025' }, // Correção: vermelha
  4: { bg: '#E8F0FE', text: '#1A73E8', border: '#D2E3FC', circle: '#1A73E8' }, // Visual: azul
  5: { bg: '#FEF7E0', text: '#E37400', border: '#FEEFC3', circle: '#E37400' }, // Refatoração: laranja
}
